import { render, staticRenderFns } from "./ContractsRecordInvoiceProducts.vue?vue&type=template&id=37ce8d6a&scoped=true"
import script from "./ContractsRecordInvoiceProducts.vue?vue&type=script&lang=js"
export * from "./ContractsRecordInvoiceProducts.vue?vue&type=script&lang=js"
import style0 from "./ContractsRecordInvoiceProducts.vue?vue&type=style&index=0&id=37ce8d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce8d6a",
  null
  
)

export default component.exports